import axios from 'axios'

export const getBenchmarkings = (companyId) =>
    axios.get(`company/${companyId}/benchmarkings`)
        .then(({ data }) => data)

export const setBenchmarkings = (companyId, benchmarkings) =>
    axios.patch(`company/${companyId}/benchmarkings`, { benchmarkings })
        .then(({ data }) => data)
